<div class="screen-alert">
  <div>
    <mat-icon class="success-icon">check_circle</mat-icon>
    <h1>{{ title }}</h1>
    @if (actionText) {
      <button mat-flat-button color="primary" [routerLink]="actionRouterLink" (click)="actionClick.emit()">
        {{ actionText }}
      </button>
    }
  </div>
</div>
